import office from '@/taskpane/officejs/office-wrapper'
import MessageArgs from '../messages/message-args'

interface SetEmailSubjectArgs extends MessageArgs {
  subject: string
}

export default async function setEmailSubjectHandler(data: SetEmailSubjectArgs) {
  try {
    await office.subject.set(data.subject)
  } catch {
    // no callback
  }
}
